<div class="main shop">
    <molla-page-header [title]="pageTitle" subtitle=""></molla-page-header> <!--include picture here-->
    <nav aria-label="breadcrumb" class="breadcrumb-nav mb-2">
        <div class="container">
            <ol class="breadcrumb">
                <li class="breadcrumb-item">
                    <a routerLink="/">Home</a>
                </li>
                <!--
                <li class="breadcrumb-item">
                    <a routerLink="/shop/sidebar/list">Shop</a>
                </li>
                -->
                <li class="breadcrumb-item active">{{ pageTitle }}</li>
                <li class="breadcrumb-item" *ngIf="searchTerm != ''">
                    <span>Search - {{ searchTerm }}</span>
                </li>
            </ol>
        </div>
    </nav>

     <!-- **************** SHOP BY BRAND SHOWING PICTURES ***********************************-->        
    <div class="container" *ngIf="category=='' && apiService.showbrandpictures">
        <div class="heading heading-flex heading-border mb-3" contentAnim aniName="blurIn">
            <div class="heading-left">
                <h2 class="title" contentAnim aniName="blurIn">Shop by Brands</h2>
            </div>
            <div class="heading-right">
            <!-- Show all Brands-->
            </div> 
        </div>
        <div class="cat-blocks-container">
            <div class="row">
                <div class="col-6 col-sm-4 col-lg-2" *ngFor="let brand of brands">
                    <a [routerLink]="['/shop/sidebar/3cols/']" [queryParams]="{brand: brand.Brand_Id, brandName: brand.Brand_name, subcategory:subcategory}" class=" brand " >
                    <!--<a (click)="routerClicked(brand.Brand_Id, brand.Brand_name, subcategory)">-->
                        <figure>
                            <span>
                                <img src="{{brands_img_path}}{{brand.Brand_code}}.png" onError="this.onerror=null; this.remove();" alt="{{brand.Brand_name}}" class="brand-image-size"> 
                            </span>
                        </figure>
                    <!-- <h3 class="cat-block-title">{{brand.Brand_name}}</h3>-->
                    <!-- <h6>{{brand.Brand_name}}</h6> -->
                    </a>
                </div>
            </div>
        </div>   
    </div>
    <!-- **************** SHOP BY BRAND NOT SHOWING PICTURES ***********************************-->     
    <div class="container" *ngIf="category=='' && !apiService.showbrandpictures">
        <div class="heading heading-flex heading-border mb-3" contentAnim aniName="blurIn">
            <div class="heading-left">
                <h2 class="title" contentAnim aniName="blurIn">Shop by Brands</h2>
            </div>
            <div class="heading-right">
            <!-- Show all Brands-->
            </div> 
        </div>
        <div class="cat-blocks-container">
            <div class="row">
                <div class="col-6 col-sm-4 col-lg-2" *ngFor="let brand of brands">
                    <a routerLink="/shop/sidebar/3cols" [queryParams]="{brand: brand.Brand_Id, brandName: brand.Brand_name}" class="brand brand-button" >
                        <!--<figure>
                            <span>
                                <img src="{{brands_img_path}}{{brand.Brand_code}}.png" onError="this.onerror=null; this.remove();" alt="{{brand.Brand_name}}" class="brand-image"> 
                            </span>
                        </figure>-->
                    <!-- <h3 class="cat-block-title">{{brand.Brand_name}}</h3>-->
                    <h6 class="category-title">{{brand.Brand_name}}</h6>
                    </a>
                </div>
            </div>
        </div>   
    </div>
    

    
    <!-- show categories if its coming from the home page master category click-->
    <div class="container" *ngIf="apiService.show_master_categories_home_page && category!='' && apiService.showcatpictures">
        <div class="heading heading-flex heading-border mb-3" contentAnim aniName="blurIn">
            <div class="heading-left">
                <h2 class="title" contentAnim aniName="blurIn">Explore Categories</h2>
            </div>
        </div>        
        <div class="cat-blocks-container">
            <div class="row">
                <div class="col-6 col-sm-4 col-lg-2" *ngFor="let cat of subcats">
                    <a routerLink="/shop/sidebar/3cols" [queryParams]="{subcategory: cat.CatID, title:cat.CatDescription}" class="cat-block" >                        
                        <figure>
                            <span>
                                <img src="{{popular_cats_img_path}}{{cat.CatCode}}.png" onError="this.onerror=null; this.remove();" alt="{{cat.CatDescription}}" class="brand-image"> 
                            </span>                                                        
                        </figure>                                                
                        <h6 class="">{{cat.CatDescription}}</h6>
                    </a>                    
                </div>                
            </div>
        </div>
    </div>
    <!-- show categories if its coming from the home page master category click  && NOT SHOWING PICTURES-->
    <div class="container" *ngIf="apiService.show_master_categories_home_page && category!='' && !apiService.showcatpictures">
        <div class="heading heading-flex heading-border mb-3" contentAnim aniName="blurIn">
            <div class="heading-left">
                <h2 class="title" contentAnim aniName="blurIn">Explore Categories</h2>
            </div>
        </div>        
        <div class="cat-blocks-container">
            <div class="row">
                <div class="col-6 col-sm-4 col-lg-2" *ngFor="let cat of subcats">
                    <a routerLink="/shop/sidebar/3cols" [queryParams]="{subcategory: cat.CatID, title:cat.CatDescription}" class="cat-block brand-button" >                        
                        <!--<figure>
                            <span>
                                <img src="{{popular_cats_img_path}}{{cat.CatCode}}.png" onError="this.onerror=null; this.remove();" alt="{{cat.CatDescription}}" class="brand-image"> 
                            </span>                                                        
                        </figure>-->
                        <h6 class="category-title">{{cat.CatDescription}}</h6>
                    </a>                    
                </div>                
            </div>
        </div>
    </div>

    <div class="page-content">
        <div class="container">
            <div class="row">
                <div class="col-lg-9 skeleton-body sekl-shop-products" [class.loaded]="loaded">
                    <div class="toolbox">
                        <div class="toolbox-left">
                            <div class="toolbox-info">
                                Showing
                                <span>{{ productsShowing }} of {{ totalCount }}</span> Products
                            </div>
                        </div>

                        <!-- **** select how many products to show on one page ****-->
                        <div class="toolbox-right">
                            <div class="toolbox-sort">
                                <label for="show_products">Products per Page: </label>
                                <div class="select-custom">
                                    <select name="show_products" id="show_products" class="form-control"
                                        (change)="changePerPage($event)" [value]="perPage">
                                        <option value="12">Default</option>
                                        <option value="24">24</option>
                                        <option value="48">48</option>
                                        <option value="96">96</option>                                        
                                    </select>
                                </div>
                            </div>                            
                        </div>
                        
                        <div class="toolbox-right">
                            <div class="toolbox-sort">
                                <label for="sortby">Sort by:</label>
                                <div class="select-custom">
                                    <select name="sortby" id="sortby" class="form-control"
                                        (change)="changeOrderBy($event)" [value]="orderBy">
                                        <option value="default">Default</option>
                                        <option value="priceLow">Price (Low->High)</option>
                                        <option value="priceHigh">Price (High->Low)</option>
                                        
                                    </select>
                                </div>
                            </div>

                            <div class="toolbox-layout">
                                <a routerLink="/shop/sidebar/list" queryParamsHandling="merge" class="btn-layout"
                                   routerLinkActive="active">
                                    <svg width="16" height="10">
                                        <rect x="0" y="0" width="4" height="4" />
                                        <rect x="6" y="0" width="10" height="4" />
                                        <rect x="0" y="6" width="4" height="4" />
                                        <rect x="6" y="6" width="10" height="4" />
                                    </svg>
                                </a>

                                <a routerLink="/shop/sidebar/2cols" queryParamsHandling="merge" class="btn-layout"
                                   routerLinkActive="active">
                                    <svg width="10" height="10">
                                        <rect x="0" y="0" width="4" height="4" />
                                        <rect x="6" y="0" width="4" height="4" />
                                        <rect x="0" y="6" width="4" height="4" />
                                        <rect x="6" y="6" width="4" height="4" />
                                    </svg>
                                </a>

                                <a routerLink="/shop/sidebar/3cols" queryParamsHandling="merge" class="btn-layout"
                                   routerLinkActive="active">
                                    <svg width="16" height="10">
                                        <rect x="0" y="0" width="4" height="4" />
                                        <rect x="6" y="0" width="4" height="4" />
                                        <rect x="12" y="0" width="4" height="4" />
                                        <rect x="0" y="6" width="4" height="4" />
                                        <rect x="6" y="6" width="4" height="4" />
                                        <rect x="12" y="6" width="4" height="4" />
                                    </svg>
                                </a>

                                <a routerLink="/shop/sidebar/4cols" queryParamsHandling="merge" class="btn-layout"
                                   routerLinkActive="active">
                                    <svg width="22" height="10">
                                        <rect x="0" y="0" width="4" height="4" />
                                        <rect x="6" y="0" width="4" height="4" />
                                        <rect x="12" y="0" width="4" height="4" />
                                        <rect x="18" y="0" width="4" height="4" />
                                        <rect x="0" y="6" width="4" height="4" />
                                        <rect x="6" y="6" width="4" height="4" />
                                        <rect x="12" y="6" width="4" height="4" />
                                        <rect x="18" y="6" width="4" height="4" />
                                    </svg>
                                </a>
                            </div>
                        </div>
                    </div>

                    <molla-shop-list-one [type]="type" [products]="product" [loaded]="loaded">
                    </molla-shop-list-one>

                    <molla-pagination [perPage]="perPage" [total]="totalCount" *ngIf="totalCount > perPage">
                    </molla-pagination>
                </div>

                <aside class="col-lg-3 skel-shop-sidebar order-lg-first skeleton-body" [class.loaded]="firstLoad">
                    <div *ngIf="!firstLoad else sidebarLoaded">
                        <div class="skel-widget"></div>
                        <div class="skel-widget"></div>
                        <div class="skel-widget"></div>
                        <div class="skel-widget"></div>
                    </div>
                    <ng-template #sidebarLoaded>
                        
                        <molla-shop-sidebar-one [toggle]="toggle">
                        </molla-shop-sidebar-one>
                        
                        <button class="sidebar-fixed-toggler" (click)="toggleSidebar()" *ngIf="toggle">
                            <i class="icon-cog"></i>
                        </button>

                        <div class="sidebar-filter-overlay" (click)="hideSidebar()"></div>
                    </ng-template>
                </aside>
            </div>
        </div>
    </div>
</div>